export default {
    paymentButton: "Pay",
    paymentPhoneError: "Your mobile number is required",
    paymentNameError: "Your name is required",
    paymentMethodError: "Payment option is required",
    serviceChargeNotification:"Service charges may vary for different payment providers",
    paymentTerms: "You must agree to the terms and conditions",
    thanksPageTitle1: "Thank you for choosing",
    thanksPageTitle2: "for your payment !",
    providerTitle: "Provider",
    instructionsTitle: "Instructions",
    thanksPageSubTitle1: "Your payment is being processed.",
    thanksPageSubTitle2: "You shall be notified once it has been completed.",
    thanksPageText:
        "If you paid via Mobile Money, there is a small chance that you may not receive the prompt from your Mobile Money Provider. In that case, you can manually \n" +
        "trigger the payment.",
    orangeInstructions:
        "Dial #150*50# to validate your withdrawal \n" +
        "in case you did not receive prompt.",
    mtnInstructions:
        "Dial *126# to validate your withdrawal in case you did not receive prompt.",
    euInstructions:
        "Just login in your Express Union Mobile App click on Authorize \n" +
        "and approve the withdrawal in case you did not receive SMS notification from Express Union.",
    yoomeeInstructions:
        "Login into your Yoomee Money Mobile App, Go to Cashout click on Incoming Cashout Request and Accept the withdrawal",
    backToShopButton: "Back to",
    backToMerchantSite: "Back to merchant site",
    successfulTransaction: "Successful transaction!",
    wasSuccessfullyTreated: "was successfully treated.",
    transactionFailed: "Transaction failed!",
    hasFailed: "has failed.",
    yourPaymentId: "Your payment",
    redirectMessage1: "You will be redirected in",
    redirectMessage2: " seconds to merchant’s site.",
    errorPageTitle: "Error.",
    errorPageSubtitle: "An error occurred during the corresponding request.",
    mobileError: "Please provide a valid mobile money number.",
    paymentError:
        "Cannot process payment: Select a payment method and provide a mobile number.",
    generalError: "General error during transaction processing.",
    contactSupport: "Contact support team ",
    backButton: "Back",
    walletIdLength: "Must be exactly 16 symbols",
    walletIdError: "Wallet ID is required",
    wrongMobileNumber: "Please enter a valid mobile money number.",
    wrongPhoneNumber: "Please enter a valid phone number",
    paypalRedirection: "You will be redirected to the PayPal's Payment Page.",
    selectProvider: "Select your payment method",
    flocashRedirection: "You will be redirected to a secured form where you will enter your credit card details, but first, you must agree to the terms and conditions to activate the button.",
    paymentFailed: "We couldn't complete your payment",
    close: "close",
    invalidEmailError: "Please enter a valid email",
    emailRequiredError: "Email address is required",
    maxNumberOfCharacters: "Maximum number of characters exeeded",
    //new translations
    verifyWalletBalance: "To avoid any payment failures, make sure you have enough money in your account.",
    shoppingCard: "Payment Summary",
    doubleCheckSelectedItems: "Please review the details of your payment below. Once ready, select a payment method to proceed.",
    product: "Product",
    quantity: "Quantity",
    unitPrice: "Unit Price/ FCFA",
    totalPrice: "Total Price/ FCFA",
    priceMobile: "Price",
    productMobile: "Items",
    subTotal: "Subtotal",
    serviceCharge: "Service charge",
    totalAmount: "Total amount",
    orderAmount: "Order Amount",
    totalToPay: "Total To Pay",
    free: "FREE",
    serviceTemporarilyUnavailable: "Service Temporarily Unavailable",
    country: "Country",
    email: "Email",
    phoneNumber: "Phone number",
    mobileMoneyNumber: "Mobile money number",
    nameAndSurname: "Name and surname",
    enterNameAndSurname: "Enter name and surname",
    enterEmailAdrress: "Enter your email address",
    provider: "Provider",
    paymentMethod: "Select a Payment Method",
    change: "Change",
    paypal: "Paypal",
    mobileMoney: "Mobile Money",
    creditCard: "Credit/Debit Card",
    english: "English",
    french: "French",
    agreeTo: "By proceeding, you agree to our",
    termsAndCondition: "Terms & Conditions",
    proceed: "Proceed",
    allRightsReserved: "All rights reserved",
    securedPlatform: "Secured by Maviance ",
    privacyPolicy: "Privacy Policy",
    termsOfService: "Terms of Service",
    and: "and",
    paymentFailedWithId: "Your payment ID: {0} has failed.",
    noCharge: "No charges were made",
    exit: "Exit",
    return: "Return to Merchant",
    redirectToMerchant: "You will be redirected to the merchant's site in...",
    awaitingPayment: "Awaiting payment",
    notififcationToWithdraw: "You will receive a notification on your phone from Maviance to withdraw",
    dialToApprove: " Dial {0} on your mobile phone to validate your withdrawal in case you do not receive a notification",
    paymentSuccessful: "Payment successful",
    successMessageWithId: "Your payment ID: {0} has been successfully processed. Your account has been debited with the amount of",
    paymentCompletedSuccessfully: "Your payment was completed successfully",
    yooMeeHint: "Login into your Yoomee Money Mobile App, Go to Cashout click on Incoming Cashout Request and Accept the withdrawal",
    expressUnionHint: "Login in your Express Union Mobile App click on Authorize and approve the withdrawal in case you did not receive SMS notification from Express Union",

    request: "Request",
    customer_cancelled_payment: "Customer cancelled the payment.",
    transaction_not_authorized: "Transaction was not authorized.",
    payment_is_pending: "Payment is pending",
    suspected_fraud: "Suspected fraud. Amount or currency customer paid not same as request.",
    merchant_void_payment: "Merchant void the payment",
    merchant_partial_refund: "Merchant partial refund the payment.",
    merchant_full_refund: "Merchant refund the payment.",
    redirect: "Redirect",
    need_more_info: "Need more info",
    expired: "expired",
    cyberSource: "Credit/Debit Card (Secure)",
    cardNumber: "Card Number",
    expiryMonth: "Expiry Month",
    expiryYear: "Expiry Year",
    securityCode: "Security Code (CVV)",
    cybersourceLoading: "Loading secure card form...",
    cybersourceError: "Failed to initialize secure card form. Please try again.",
    cybersourceTokenError: "Card details could not be verified. Please check and try again.",
    payNow: "Pay Now",
};
